import { BUITheme } from '@blofin/blofin-ui';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';

function useChangeTheme(isHasDarkMode: boolean, initTheme: BUITheme = 'light') {
  const [themeValue, setThemeValue] = useState<{ theme: BUITheme }>(() => {
    return { theme: initTheme === 'dark' ? 'dark' : 'light' };
  });

  const changeTheme = useCallback((theme: BUITheme) => {
    Cookies.set('theme', theme, { expires: 999 });
    localStorage?.setItem('theme', theme);
    document.getElementsByTagName('html')[0].setAttribute('data-theme', theme);
    setThemeValue({ theme });
  }, []);

  useEffect(() => {
    requestAnimationFrame(() => {
      const html = document.getElementsByTagName('html')[0];
      html?.setAttribute?.('data-theme', themeValue.theme);
      html?.removeAttribute?.('style');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme: BUITheme = isHasDarkMode ? themeValue.theme : 'light';

  return { changeTheme, theme };
}

export default useChangeTheme;
